import React from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';
import ApprovalDialogBody from '../ApprovalDialogBody';

const CancelDialog = ({ msg, onClose, onAccept, ...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { onClose }
        cancelButton={{
            action: onClose,
            label: 'NO'
        }}
        acceptButton={{
            action: onAccept,
            label: 'YES, CANCEL'

        }}
        header="Do you confirm that  you Cancel this Exception?"
        body={<ApprovalDialogBody msg={msg} />}
    />;

export default CancelDialog;